<template>
    <rkm-overlay>
        <rkm-layout-body title="Parametrização">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content no-card-style>
                <Form
                    :key="count"
                    @data-load="handleDataLoaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/farmacia/parametrizacao/Form'

import { mapActions } from 'vuex'

export default {
    components: { Form },
    data: () => ({
        count: 1,
        data: null,
        unwatchers: {
            unwatchData: null
        }
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleDataLoaded(data) {

            this.data = data

            this.addDataWatcher()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()

            this.count++

        },
        addDataWatcher() {

            this.unwatchData = this.$watch('data', {
                deep: true,
                handler() {

                    this.setShowExitFormConfirmation()
                    this.unwatchData()
                }
            })
        }
    },
}
</script>